// extracted by mini-css-extract-plugin
export default {"marginLoader":"Loader_marginLoader__KO+72"};